// Libraries
import * as React from 'react';
import DevTools from 'mobx-react-devtools';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Router, Route, Switch, Redirect } from 'react-router';
import * as superagent from 'superagent';
import hooks = require('feathers-hooks');
import feathers = require('feathers/client');
import rest = require('feathers-rest/client');
import authentication = require('feathers-authentication-client');
import * as localForage from 'localforage';

// History
import createBrowserHistory from 'history/createBrowserHistory';
export const browserHistory = createBrowserHistory({
    forceRefresh: false
});

// Interfaces
import { IAppOnlyStore } from './stores/AllStores';

export interface IAuthConfig {
    strategy?: string;
    username?: string;
    email?: string;
    password?: string;
}

export interface IPassportConfig extends authentication.Passport {
    verifyJWT(token: string): Promise<any>;
}

export interface IFeathersApp extends feathers.Application {
    authenticate(config: IAuthConfig): Promise<any>;
    logout(): Promise<any>;
    passport: IPassportConfig;
}

// Routes
import { Login } from './routes/user/login';
import { Logout } from './routes/user/logout';
import { Main } from './routes';
import { PageNotFound, PageForbidden } from './routes/errors';
import { pages } from '../data/content';
import { WebBrowserIsUnsupported } from './routes/unsupported';

// Environment variables
declare const process: any;

const isDevEnvironment: boolean =
    typeof process !== 'undefined' &&
    typeof process.env !== 'undefined' &&
    typeof process.env.NODE_ENV !== 'undefined' &&
    process.env.NODE_ENV === 'development'
        ? true
        : false;

const apiHost: string =
    typeof process !== 'undefined' && typeof process.env !== 'undefined' && typeof process.env.API_HOST !== 'undefined'
        ? process.env.API_HOST
        : 'http://localhost:3030';

// API connection
export const restClient = rest(apiHost);
export const app: IFeathersApp = feathers()
    .configure(restClient.superagent(superagent, { timeout: 15000 }))
    .configure(hooks())
    .configure(authentication({ storage: localForage as any })) as IFeathersApp;

// Component
@inject('store')
@observer
export default class App extends React.Component<IAppOnlyStore, {}> {
    constructor(props: IAppOnlyStore) {
        super(props);

        if (typeof this.props.store !== 'undefined') {
            this.props.store.user
                .relogin()
                .then(response => {
                    this.isLocalStorageTokenChecked = true;
                })
                .catch(error => {
                    console.error('Could not relogin', error);
                    this.isLocalStorageTokenChecked = true;
                });
        }

        if (
            typeof window === 'undefined' ||
            typeof window.navigator === 'undefined' ||
            typeof window.navigator.userAgent === 'undefined' ||
            (window.navigator.userAgent.indexOf('MSIE') !== -1 && window.navigator.userAgent.indexOf('Trident/') !== -1)
        ) {
            this.isWebBrowserSupported = false;
        }

        this.isWebBrowserChecked = true;
    }

    @observable private isLocalStorageTokenChecked: boolean = false;
    @observable private isWebBrowserChecked: boolean = false;
    @observable private isWebBrowserSupported: boolean = true;

    public render() {
        return (
            <div id="app">
                {this.isLocalStorageTokenChecked &&
                    this.isWebBrowserChecked &&
                    this.isWebBrowserSupported && (
                        <Router history={browserHistory}>
                            <Switch>
                                <Route path="/user/login" exact component={Login} />
                                <Route path="/user/logout" exact component={Logout} />

                                {pages.map(page => page.route)}

                                <Route path="/" exact component={Main} />

                                <Route component={PageNotFound} />
                            </Switch>
                        </Router>
                    )}

                {this.isWebBrowserChecked && this.isWebBrowserSupported === false && <WebBrowserIsUnsupported />}

                {isDevEnvironment && <DevTools />}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/App.tsx